import { styled } from '@mui/material';

export const CarName = styled('div')(() => ({
  color: '#202021',
  fontWeight: 600,
  fontSize: 24,
}));
